import styled from "styled-components"

import ToggleButton from "components/modules/inputs/ToggleButton"

export default function PushConfigItem({ title, desc, name, isChecked, onChange }) {
  return (
    <Block>
      <ItemInfo>
        <ItemTitle>{title}</ItemTitle>
        <ItemDesc>{desc}</ItemDesc>
      </ItemInfo>
      <ToggleButton onChange={onChange} name={name} checked={isChecked} />
    </Block>
  )
}

const Block = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & + & {
    margin-top: calc(100vw * (23 / 375));
  }
`

const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
`

const ItemTitle = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (20 / 375));
  color: #4e4e4e;
`

const ItemDesc = styled.span`
  font-size: calc(100vw * (12 / 375));
  font-weight: 400;
  line-height: calc(100vw * (17 / 375));
  color: #9a9a9f;
`
